import * as React from 'react'
import { Box } from '@mui/material'
import { OSEIngest } from './OpenSciEd/OSEIngest'
import { Ingest as IM360 } from './IM360/Ingest'
import { Ingest as IMAIGenerated } from './AIGenerated/Test'
import { PartnerContext } from './PartnerContext'
import { useParams } from 'infrastructure/routing'
import { useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { partnerIdAtom } from '../components/ingestion/atoms'

export function Test() {
  const { partnerId } = useParams()
  useSetAtom(partnerIdAtom)(partnerId ?? '')
  function PartnerComponent() {
    switch (partnerId) {
      case 'OpenSciEd':
        return <OSEIngest />
      case 'IM360':
        return <IM360 />
      case 'IMAIGenerated':
        return <IMAIGenerated />
    }
    return <Box>Not Found: {partnerId}</Box>
  }

  return (
    <Box>
      <PartnerContext.Provider value={partnerId}>
        <PartnerComponent />
      </PartnerContext.Provider>
    </Box>
  )
}
